export const mybloggy_mern = [
    {
        id:1, 
        skill:'MongoDB',
        icon:'fa fa-database fa-2x yellow-text'
    },
    {
        id:2, 
        skill:'Express',
        icon:'fas fa-server fa-2x orange-text'
    },
    {
        id:3, 
        skill:'React (hook)',
        icon:'fab fa-2x fa-react'
    },
    {
        id:4, 
        skill:'NodeJs',
        icon:'fab fa-node fa-2x green-text'
    },
]

export const mybloggy_skills = [
    {
        id:1, 
        skill:'HTML5',
        icon:'fab fa-html5 fa-2x'
    },
    {
        id:2, 
        skill:'JavaScript (ES6)',
        icon:'fab fa-js-square fa-2x yellow-text'
    },
    {
        id:3, 
        skill:'Bootstrap5',
        icon:'fab fa-bootstrap fa-2x purple-text'
    },
    {
        id:4, 
        skill:'CSS',
        icon:'fab fa-css3-alt fa-2x red-text'
    },
    {
        id:5, 
        skill:'Redux',
        icon:'fas fa-store-alt fa-2x purple-text'
    },

    {
        id:6, 
        skill:'REST API',
        icon:'fas fa-paper-plane fa-2x red-text'
    },

    {
        id:7, 
        skill:'JWT',
        icon:'fas fa-coins fa-2x orange-text'
    },

    {
        id:8, 
        skill:'Async/Await',
        icon:'far fa-handshake fa-2x green-text'
    },

    {
        id:9, 
        skill:'JSX',
        icon:'fab fa-react fa-2x blue-text'
    },
    {
        id:10, 
        skill:'Multer',
        icon:'fas fa-camera fa-2x pink-text'
    },

    {
        id:11, 
        skill:'Cloudinary',
        icon:'fas fa-cloud fa-2x blue-text'
    },

    {
        id:12, 
        skill:'bcrypt',
        icon:'fas fa-key fa-2x grey-text'
    },

    {
        id:12, 
        skill:'gravatar',
        icon:'fas fa-user-alt fa-2x yellow-text'
    },

    {
        id:13, 
        skill:'express-validator',
        icon:'fas fa-check fa-2x green-text'
    },

    {
        id:14, 
        skill:'MDBoostrap',
        icon:'fab fa-mdb fa-2x blue-text'
    }












]